/* eslint-disable @typescript-eslint/naming-convention */


// eslint-disable-next-line no-shadow
export enum ErrorEvents {
  //Events for Developers
  TABS_FETCH_ERROR = 'TABS_FETCH_ERROR',
  COLLECTION_FETCH_ERROR = 'COLLECTION_FETCH_ERROR',
  CONTAINER_FETCH_ERROR = 'CONTAINER_FETCH_ERROR',
  RESOURCE_FETCH_ERROR = 'RESOURCE_FETCH_ERROR',
  SERIES_FETCH_ERROR = 'SERIES_FETCH_ERROR',
  EPISODES_FETCH_ERROR = 'EPISODES_FETCH_ERROR',
  SEARCH_FETCH_ERROR = 'SEARCH_FETCH_ERROR',
  RELATED_FETCH_ERROR = 'RELATED_FETCH_ERROR',
  UPNEXT_FETCH_ERROR = 'UPNEXT_FETCH_ERROR',
  PLAYBACK_ERROR = 'PLAYBACK_ERROR',
  DEVICE_REGISTRATION_ERROR = 'DEVICE_REGISTRATION_ERROR',
  SESSION_ERROR = 'SESSION_ERROR',
  ENTITLEMENTS_ERROR = 'ENTITLEMENTS_FETCH_ERROR',
  GENERAL_ERROR = 'ERROR',
  ADD_WATCHLIST_ERROR = 'ADD_WATCHLIST_ERROR',
  REMOVE_WATCHLIST_ERROR = 'REMOVE_WATCHLIST_ERROR',
}